/*
  YZIA — POPUP NEWSLETTER global + languette latérale.
  Non intrusif : pas d'affichage au chargement. Auto-affichage UNE fois après un délai
  OU après X% de scroll (le premier des deux). Fermeture (croix / clic dehors / Échap)
  ou inscription → localStorage pose une fenêtre de N jours sans réaffichage auto.
  La languette rouvre le popup à tout moment (ignore le cooldown). Focus géré, Échap,
  reduced-motion = simple fondu (CSS). JS GLOBAL = chargement fiable (defer).
*/
(function () {
  var root = document.getElementById('facil-popup-root');
  if (!root) return;

  var popup = root.querySelector('.facil-popup');
  var dialog = root.querySelector('.facil-popup__dialog');
  if (!popup || !dialog) return;

  var openers = root.querySelectorAll('[data-popup-open]');
  var closers = root.querySelectorAll('[data-popup-close]');
  var form = popup.querySelector('form');
  var emailInput = popup.querySelector('input[type="email"]');

  var days = parseInt(root.getAttribute('data-days'), 10) || 7;
  var delay = (parseInt(root.getAttribute('data-delay'), 10) || 15) * 1000;
  var scrollPct = parseInt(root.getAttribute('data-scroll'), 10) || 40;
  var KEY = 'facil_popup_dismissed_until';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var isOpen = false;
  var autoShown = false;
  var lastFocus = null;
  var timer = null;

  function dismissed() {
    try {
      var until = parseInt(window.localStorage.getItem(KEY), 10);
      return until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }
  function setDismiss() {
    try {
      window.localStorage.setItem(KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') close(true);
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    clearTriggers();
    lastFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKey);
    var target = emailInput || dialog.querySelector('[data-popup-close]');
    if (target) {
      window.setTimeout(function () {
        try { target.focus(); } catch (e) {}
      }, 60);
    }
  }

  function close(markDismiss) {
    if (!isOpen) return;
    isOpen = false;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey);
    if (markDismiss) setDismiss();
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  function autoShow() {
    if (autoShown || isOpen) return;
    autoShown = true;
    open();
  }

  function onScroll() {
    var st = window.scrollY || document.documentElement.scrollTop || 0;
    var h = (document.documentElement.scrollHeight || 0) - window.innerHeight;
    if (h > 0 && (st / h) * 100 >= scrollPct) autoShow();
  }

  function clearTriggers() {
    if (timer) { window.clearTimeout(timer); timer = null; }
    window.removeEventListener('scroll', onScroll);
  }

  // Ouverture/fermeture manuelles.
  Array.prototype.forEach.call(openers, function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  Array.prototype.forEach.call(closers, function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); close(true); });
  });

  // Inscription = on ne le réaffiche plus automatiquement.
  if (form) form.addEventListener('submit', function () { setDismiss(); });

  // Déclencheurs auto : délai OU scroll (le premier qui arrive), sauf cooldown / design mode.
  // Pas d'auto-ouverture « sur succès » : le footer a sa propre newsletter (même form
  // customer), et Shopify marque posted_successfully? sur toutes → éviterait un faux trigger.
  if (!dismissed() && !designMode) {
    timer = window.setTimeout(autoShow, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Theme editor : ouvre quand la section est sélectionnée, ferme au désélect.
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.contains(root)) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.contains(root)) close(false);
  });
})();
